import script from "./AppLink.vue?vue&type=script&lang=js"
export * from "./AppLink.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__